import { Button, Card, List, Typography } from 'antd';
import styled from 'styled-components';
import DrawerWithAutoWidth from '../../../components/DrawerWithAutoWidth';
import breakpoints from '../../../utilities/breakpoints';

export const Title = styled(Typography.Title).attrs(() => ({
    level: 4,
}))`
    && {
        margin: 0;
        font-size: 18px;
    }
`;

export const Subtitle = styled(Typography.Title).attrs(() => ({
    level: 5,
}))`
    margin: 0;
`;

export const SecondaryText = styled(Typography.Text).attrs(() => ({
    type: 'secondary',
}))<{ hasMaxWidth?: boolean }>`
    margin: 0;
    max-width: ${({ hasMaxWidth }) => (hasMaxWidth ? 'calc(100% - 48px);' : '100%;')};
    text-align: start;
    word-break: break-all;
    && {
        font-size: 14px;
    }
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 24px 24px;
    max-width: 30vw;

    @media screen and (max-width: ${breakpoints.lg}) {
        max-width: 70vw;
    }

    @media screen and (max-width: ${breakpoints.sm}) {
        max-width: 90vw;
    }
`;

export const ProfileCardWrapper = styled.div`
    padding: 16px 0px 24px;
    width: 100%;

    && {
        .ant-card {
            width: 239px;
        }
    }
`;

export const PageTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    text-align: center;

    & .ant-typography {
        flex: 1;
    }

    svg {
        fill: var(--ant-primary-color);
    }
`;

export const StyledDrawer = styled(DrawerWithAutoWidth)`
    & .ant-drawer-header {
        border-bottom: none;
    }
    .ant-drawer-body {
        padding: 0px;
    }

    & .ant-drawer-close {
        margin-left: -9px;
        margin-right: -9px !important;
    }

    & .ant-drawer-close > .anticon svg {
        color: black;
    }
`;

export const MenuList = styled(List).attrs(() => ({
    bordered: false,
}))`
    background: #fafafa;
    height: 100%;

    &.ant-list {
        padding: 24px;
    }
`;

export const ListItem = styled(List.Item)`
    border-bottom: none !important;
    cursor: pointer;

    & .anticon {
        color: var(--ant-primary-color);
    }
`;

export const AvatarContainer = styled.div`
    padding-bottom: 24px;
`;

export const ActionButton = styled(Button)`
    && {
        margin-left: -9px;
        margin-right: -9px;
    }
`;

export const StyledCard = styled(Card)`
    width: 100%;
    margin-bottom: 24px;

    & .ant-card-body {
        padding: 16px 24px;
    }
`;

export const RevokeButton = styled(Button).attrs(() => ({
    type: 'link',
}))`
    && {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;

        svg {
            margin: 0 8px;
            fill: var(--ant-primary-color);
        }

        :disabled {
            svg {
                fill: rgba(0, 0, 0, 0.25);
            }
        }
    }
`;

export const PasswordRequirementsContainer = styled.div`
    background: #eeeff2;
    padding: 16px;
    margin-top: 10px;
    border-radius: 2px;
`;

export const ContactItemWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    svg {
        margin: 4.2px 10px;
        fill-opacity: 0.45;
    }
`;
